// @flow
import { useLocation } from '@reach/router'
import * as React from 'react'

type UTMData = Array<[string, string]>

declare var globalThis: any

const UTM_PREFIXED = /^utm_/

const SESSION_ITEM_KEY = 'track_utm_data'

const getInitialData = () => {
  if (globalThis.sessionStorage) {
    return JSON.parse(sessionStorage.getItem(SESSION_ITEM_KEY) || '[]')
  }

  return []
}

export function useUTM(): [UTMData] {
  const location = useLocation()
  const [utmData, setUtmData] = React.useState(getInitialData())

  const setUTM = React.useCallback((search: string) => {
    const searchParams = new URLSearchParams(search)
    const memo = []

    for (let data of searchParams.entries()) {
      const [key] = data

      if (key.match(UTM_PREFIXED)) {
        memo.push(data)
      }
    }

    if (memo.length) {
      sessionStorage.setItem(SESSION_ITEM_KEY, JSON.stringify(memo))
      setUtmData(memo)
    }
  }, [])

  React.useEffect(() => {
    setUTM(location.search)
  }, [location.search, setUTM])

  return [utmData]
}

const getKey = (key: string): string => {
  // $FlowFixMe[not-an-array]: Flow doesnt know that strings can be destructed like arrays feelsbadman
  const [firstChar, ...rest] = key.replace(`utm_`, '')

  return `${firstChar.toUpperCase()}${rest.join('')}`
}

export const stringifyUTM = (data: UTMData): string => {
  return data
    .reduce((memo, [key, value]) => {
      memo.push(`${getKey(key)}=${value}`)
      return memo
    }, [])
    .join(' | ')
}
